<template>
  <div class="tab-pane active" id="form-step-2">
    <div class="row">
       <message-box :type="1" />
      <datetime-picker v-if="isGBGVerified" :gbgverified="isGBGVerified"/>
      <Loading v-if="loading" />
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import mixin from "@/components/shared/mixinUtility";
import Loading from "@/components/ui/Loading.vue";
import MessageBox from "@/components/ui/MessageBox.vue";
import DateTimePicker from "@/components/ui/DateTimePicker.vue";
export default {
  name: "Thankyou",
  mixins: [mixin],
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapGetters({
      currentActive: "getCurrentActive",
      actions: "getActions",
      contactId: "getContactId",
      jwtToken:"getJwtToken"
    }),
  },
  components: {
    Loading,
      "message-box": MessageBox,
      "datetime-picker": DateTimePicker,
  }
};
</script>
